// garuda - Home Page

import React, { useEffect, useRef } from "react";
import { useNavigation, STAGES } from "../context/NavigationContext";
import {
  DoorIcon,
  TerminalPromptBg,
  GithubIcon,
  LinkedInIcon,
  MailIcon,
  InstagramIcon,
} from "../components/Icons";
import { triggerJackpotAnimation } from "../utils/helpers";
import "./Home.css";

const Home = () => {
  const { navigateTo } = useNavigation();
  const hasTyped = useRef(false);

  useEffect(() => {
    const jackpotWord = document.querySelector(".hero-title .jackpot-word");
    if (jackpotWord) {
      const handleJackpotSpin = (e) => triggerJackpotAnimation(e.target);
      jackpotWord.addEventListener("mouseenter", handleJackpotSpin);
      return () =>
        jackpotWord.removeEventListener("mouseenter", handleJackpotSpin);
    }
  }, []);

  useEffect(() => {
    // Animate neofetch lines in sequence with typing effect
    if (hasTyped.current) return;
    hasTyped.current = true;

    const lines = document.querySelectorAll(".neofetch-line");

    lines.forEach((line, index) => {
      const key = line.querySelector(".neofetch-key");
      const value = line.querySelector(".neofetch-value");

      if (key && value) {
        const keyText = key.getAttribute("data-text");
        const valueText = value.getAttribute("data-text");
        const baseDelay = index * 1000; // 1s between lines

        // Clear initial text
        key.textContent = "";
        value.textContent = "";

        // Type key character by character
        setTimeout(() => {
          let keyIndex = 0;
          const keyInterval = setInterval(() => {
            if (keyIndex < keyText.length) {
              key.textContent += keyText[keyIndex];
              keyIndex++;
            } else {
              clearInterval(keyInterval);

              // Add colon after key
              key.textContent += ":";

              // Start typing value after key finishes
              setTimeout(() => {
                let valueIndex = 0;
                const valueInterval = setInterval(() => {
                  if (valueIndex < valueText.length) {
                    value.textContent += valueText[valueIndex];
                    valueIndex++;
                  } else {
                    clearInterval(valueInterval);
                    // Remove blinking cursor after done
                    value.classList.add("typing-complete");
                  }
                }, 40); // 40ms per character for value
              }, 100);
            }
          }, 50); // 50ms per character for key
        }, baseDelay);
      }
    });
  }, []);

  const handleDoorClick = () => {
    navigateTo(STAGES.STAGE_1);
  };

  return (
    <div className="home-container">
      <TerminalPromptBg opacity={0.05} />

      {/* Hero Section */}
      <section className="hero-section">
        <h1 className="hero-title">
          This is not a{" "}
          <span className="jackpot-word" data-original="portfolio">
            portfolio
          </span>
        </h1>
        <p className="hero-subtitle">This is a personal diary.</p>
      </section>

      {/* Neofetch Display */}
      <section className="neofetch-section">
        <div className="neofetch-container">
          <pre className="neofetch-output">
            <span className="neofetch-logo">
              {`    ██████╗  █████╗
    ██╔══██╗██╔══██╗
    ██████╔╝███████║
    ██╔═══╝ ██╔══██║
    ██║     ██║  ██║
    ╚═╝     ╚═╝  ╚═╝`}
            </span>
            <div className="neofetch-info">
              <div className="neofetch-line">
                <span className="neofetch-key" data-text="Name">
                  Name
                </span>
                <span className="neofetch-value" data-text="Prem Agarwal">
                  Prem Agarwal
                </span>
              </div>
              <div className="neofetch-line">
                <span className="neofetch-key" data-text="Education">
                  Education
                </span>
                <span className="neofetch-value" data-text="IIT Kharagpur">
                  IIT Kharagpur
                </span>
              </div>
              <div className="neofetch-line">
                <span className="neofetch-key" data-text="Interests">
                  Interests
                </span>
                <span
                  className="neofetch-value"
                  data-text="code, music, design"
                >
                  code, music, design
                </span>
              </div>
              <div className="neofetch-line">
                <span className="neofetch-key" data-text="Hometown">
                  Hometown
                </span>
                <span className="neofetch-value" data-text="Kolkata">
                  Kolkata
                </span>
              </div>
              <div className="neofetch-line">
                <span className="neofetch-key" data-text="DOB">
                  DOB
                </span>
                <span className="neofetch-value" data-text="MTcxMTIwMDQ=">
                  MTcxMTIwMDQ=
                </span>
              </div>
            </div>
          </pre>
        </div>
      </section>

      {/* Philosophy Quote - Entry Point */}
      <section className="philosophy-section">
        <p className="quote-philosophy glow">
          The path starts where the light leads.
        </p>
        <div className="door-container" onClick={handleDoorClick}>
          <DoorIcon className="door-icon" />
          <span className="door-hint">Enter</span>
        </div>
      </section>

      {/* Footer with Socials */}
      <footer className="home-footer">
        <div className="social-links">
          <a
            href="https://github.com/premagarwals"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            <GithubIcon />
          </a>
          <a
            href="https://www.linkedin.com/in/premagarwal"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            <LinkedInIcon />
          </a>
          <a
            href="mailto:prem129377@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            <MailIcon />
          </a>
          <a
            href="https://instagram.com/impremagarwal"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            <InstagramIcon />
          </a>
        </div>
        <p className="footer-text">© 2026 garuda</p>
      </footer>
    </div>
  );
};

export default Home;
